import ApiCore from "../utilities/core";

const url = 'permissions';
const plural = 'permissions';
const single = 'permission';

export const apiPermissions = new ApiCore({
    getAll: true,
    getSingle: true,
    post: true,
    put: true,
    patch: true,
    delete: true,
    url: url,
    plural: plural,
    single: single,
    requireToken: true
});

